export default "__VITE_ASSET__DevAop_K__"